import { render } from "./MyCardTabVideo.vue?vue&type=template&id=d2838742&scoped=true&bindings={}"
import script from "./MyCardTabVideo.vue?vue&type=script&lang=ts"
export * from "./MyCardTabVideo.vue?vue&type=script&lang=ts"

import "./MyCardTabVideo.vue?vue&type=style&index=0&id=d2838742&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d2838742"

export default script